var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubscribe = function SvgSubscribe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.828 8.959h4.312V4.646",
    stroke: "#134F46",
    strokeWidth: 1.688,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.09 17.09a7.906 7.906 0 1 1 0-11.18l3.05 3.049",
    stroke: "#134F46",
    strokeWidth: 1.688,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgSubscribe as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjgyNzYgOC45NTg5OUgyMC4xNDAxVjQuNjQ2NDgiIHN0cm9rZT0iIzEzNEY0NiIgc3Ryb2tlLXdpZHRoPSIxLjY4NzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTcuMDkwNiAxNy4wOTA2QzE1Ljk4NDkgMTguMTk2MyAxNC41NzYxIDE4Ljk0OTMgMTMuMDQyNCAxOS4yNTQzQzExLjUwODggMTkuNTU5NCA5LjkxOTA5IDE5LjQwMjggOC40NzQ0MSAxOC44MDQ0QzcuMDI5NzMgMTguMjA2IDUuNzk0OTQgMTcuMTkyNyA0LjkyNjE5IDE1Ljg5MjVDNC4wNTc0NCAxNC41OTIzIDMuNTkzNzUgMTMuMDYzNyAzLjU5Mzc1IDExLjVDMy41OTM3NSA5LjkzNjMgNC4wNTc0NCA4LjQwNzcgNC45MjYxOSA3LjEwNzUzQzUuNzk0OTQgNS44MDczNSA3LjAyOTczIDQuNzkzOTkgOC40NzQ0MSA0LjE5NTU4QzkuOTE5MDkgMy41OTcxOCAxMS41MDg4IDMuNDQwNjEgMTMuMDQyNCAzLjc0NTY3QzE0LjU3NjEgNC4wNTA3MyAxNS45ODQ5IDQuODAzNzMgMTcuMDkwNiA1LjkwOTQ0TDIwLjE0IDguOTU4ODQiIHN0cm9rZT0iIzEzNEY0NiIgc3Ryb2tlLXdpZHRoPSIxLjY4NzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";